module.exports = __webpack_public_path__ + "img/88.be44526a.png";